/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Status {
  Inactive = 'Inactive',
  Unavailable = 'Unavailable',
  Open = 'Open',
  Closed = 'Closed'
}
